import { v4 as uuid } from 'uuid';
import { create } from 'zustand';
import { DEVICE_LEVEL } from '@tving/utils/src/constants/commonConstants';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
import DeviceManagerInstance from '@tving/utils/src/utils/device';
var deviceType = getDeviceType();
/**
 * 시스템 전반적으로 사용되는 기기 정보를 관리합니다.
 */
var device = create(function (set) { return ({
    uuid: localStorage.getItem('uuid') || uuid(),
    deviceType: deviceType,
    deviceInfo: DeviceManagerInstance.getDeviceInfo(),
    setDeviceInfo: function (deviceInfo) {
        set(function () { return ({
            deviceInfo: deviceInfo,
        }); });
    },
    deviceLevel: DEVICE_LEVEL.NORMAL,
    setDeviceLevel: function (deviceLevel) {
        if (deviceLevel === DEVICE_LEVEL.LOW) {
            set(function () { return ({
                isPreviewAvailable: false,
                isBoardAnimationAvailable: false,
                deviceLevel: deviceLevel,
            }); });
        }
        else {
            set(function () { return ({
                deviceLevel: deviceLevel,
            }); });
        }
    },
    isBandAnimationAvailable: true,
    isBoardAnimationAvailable: true,
    isPreviewAvailable: true,
    isDimAvailable: true,
}); });
export var useDeviceStore = device;
